export const GLOSSARY_GET_REQUESTING = "GLOSSARY_GET_REQUESTING";
export const GLOSSARY_GET_SUCCESS = "GLOSSARY_GET_SUCCESS";
export const GLOSSARY_GET_ERROR = "GLOSSARY_GET_MATCH_ERROR";
export const GLOSSARY_SEND_WORD = "GLOSSARY_SEND_WORD";
export const GLOSSARY_RECEIVE_WORDS = "GLOSSARY_RECEIVE_WORDS";
export const GLOSSARY_SORT_BY_OCCURRENCE = "GLOSSARY_SORT_BY_OCCURRENCE";
export const GLOSSARY_SORT_ALPHABETICALLY = "GLOSSARY_SORT_ALPHABETICALLY";
export const GLOSSARY_ON_CHANGE = "GLOSSARY_ON_CHANGE";
export const GLOSSARY_DELETE_WORD_REQUESTING =
  "GLOSSARY_DELETE_WORD_REQUESTING";
export const GLOSSARY_DELETE_WORD_SUCCESS = "GLOSSARY_DELETE_WORD_SUCCESS";
export const GLOSSARY_DELETE_WORD_ERROR = "GLOSSARY_DELETE_WORD_ERROR";
export const GLOSSARY_MODIFY_DEFINITION_REQUESTING =
  "GLOSSARY_MODIFY_DEFINITION_REQUESTING";
export const GLOSSARY_MODIFY_DEFINITION_SUCCESS =
  "GLOSSARY_MODIFY_DEFINITION_SUCCESS";
export const GLOSSARY_MODIFY_DEFINITION_ERROR =
  "GLOSSARY_MODIFY_DEFINITION_ERROR";
